var Message = require('../lib/message');

module.exports = Message;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.messageCenter/app/index.js